import React from "react";

const STEPS = [
  { n: 1, title: "Fill in a form", key: "form" },
  { n: 2, title: "Preview and add photos", key: "preview" },
  { n: 3, title: "Create and request approval", key: "done" },
];

const stepMeta = (stepKey, screen) => {
  const order = { form: 1, preview: 2, done: 3 };
  const current = order[screen] || 1;
  const step = order[stepKey];
  if (step < current) return { state: "Done", className: "bg-green-700 text-white" };
  if (step === current) {
    return { state: "In progress", className: "bg-secondaryColor text-white" };
  }
  return {
    state: "Waiting",
    className: "bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200",
  };
};

const StepHeader = ({ screen }) => (
  <ol className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-4">
    {STEPS.map((step) => {
      const meta = stepMeta(step.key, screen);
      return (
        <li
          key={step.key}
          className="flex min-w-[200px] flex-1 items-center gap-3 rounded-md border border-gray-300 px-4 py-3 dark:border-gray-600"
        >
          <span
            className={`flex h-8 w-8 flex-none items-center justify-center rounded-full text-sm font-bold ${meta.className}`}
          >
            {step.n}
          </span>
          <div>
            <div className="font-medium">{step.title}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {meta.state}
            </div>
          </div>
        </li>
      );
    })}
  </ol>
);

export default StepHeader;
